import React from 'react';

import { formatDate } from 'utils/helpers/date';

import { InfoFields, InfoColumn } from './styledComponents';

import { MissingScheduledShippingDate } from './MissingScheduledShippingDate';

const ShipmentBlock = ({ lineData, ...props }) => {
  return (
    <InfoFields {...props}>
      <InfoColumn>
        <div style={{ width: 'max-content' }}>
          <b>Scheduled Shipment Date:</b>{' '}
          {formatDate(lineData.scheduledShipDate) || <MissingScheduledShippingDate />}
        </div>
        <div>
          <b>Actual Shipment Date:</b> {formatDate(lineData.actualShipDate)}
        </div>
      </InfoColumn>
      {lineData.isPackage ? null : (
        <InfoColumn>
          <div>
            <b>Shipping Method:</b> {lineData.shippingMethod}
          </div>
          <div>
            <b>Waybill Number:</b> {lineData.waybillNumber}
          </div>
        </InfoColumn>
      )}
    </InfoFields>
  );
};

export { ShipmentBlock };
